import { Box, styled, Typography } from "@mui/material"
import AndroidIcon from "icons/Technologies/Android.icon"

interface Technology {
    id: string;
    name: string;
    description: string;
    field: number;
    updatedOnUtc: string;
}

interface AdminTechnologyCardProps {
    technology: Technology;
}

const StyledCard = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '28px',
    backgroundColor: '#fff',
    border: '1px solid var(--Light-Gray)',
    borderRadius: '12px',
    boxShadow: '0px 1px 2px 0px #0205111A',
    padding: '20px',
    [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
    },
}));

const AdminTechnologyCard = ({ technology }: AdminTechnologyCardProps) => {
    return (
        <StyledCard>
            <Box sx={{display: 'flex', gap: '16px'}}>
                <AndroidIcon />
                <Box sx={{display: 'flex', flexDirection: 'column' ,gap: '4px'}}>
                    <Typography variant="h2">{technology.name}</Typography>
                    <Typography variant="h5" sx={{color: 'var(--Interviewer-Lighter-Black)'}}>{technology.description}</Typography>
                </Box>
            </Box>
            <Box sx={{backgroundColor: 'var(--Light-Gray)', borderRadius: '8px', padding: '6px 14px', height: 'fit-content', ml: { md: 'auto'},}}>
                <Typography sx={{color: 'var(--Interviewer-Lighter-Black)', fontSize: '14px', fontWeight: '600'}}>217 Questions</Typography>
            </Box>
        </StyledCard>
    )
}
export default AdminTechnologyCard